import React, { Component } from "react";
import Cookies from "universal-cookie";
import moment from "moment";
import { Buffer } from "buffer";

import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";

import { orderService } from "../../services/otodisApi/OrderService";

import { Button, Col, DatePicker, Form, Input, Row, Modal, Upload, Space } from "antd";

import { SaveOutlined, UndoOutlined, InboxOutlined, SearchOutlined } from "@ant-design/icons";

import { DeliveryHandoverStates } from "./types/DeliveryHandoverTypes";
import { baseUrlCdnUpload } from "../../config/api/apiConfig";

export interface DeliveryHandoverStatesProps {}

class DeliveryHandover extends Component<DeliveryHandoverStatesProps & any, DeliveryHandoverStates> {
  private readonly initState!: DeliveryHandoverStates;
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");

  constructor(props: (DeliveryHandoverStatesProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");

    this.initState = {
      processing: false,
      submitting: false,

      dealerCode: finalDealerCode,
      engineNumber: "",
      orderCode: "",
      customerName: "",
      offerCode: "",
      orderStatus: "",
      vehicleVariantName: "",
      marketingName: "",
      paymentMethod: "",
      handoverDate: moment().clone().format("YYYY-MM-DD"),
      receiverNik: "",
      receiverName: "",
      receiverPhone: "",
      receiverSignature: "",
      receiverSignatureThumb: "",
      handoverProof: "",
      handoverProofThumb: "",
      showUploadList: true,
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
    });
  };

  onStringFieldChange = <T extends keyof Pick<any, "engineNumber" | "orderCode" | "handoverDate" | "receiverNik" | "receiverName" | "receiverPhone" | "receiverSignature" | "handoverProof">>(
    target: T,
    value: any
  ) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "engineNumber":
        currentState.engineNumber = value;
        break;
      case "orderCode":
        currentState.orderCode = value;
        break;
      case "handoverDate":
        currentState.handoverDate = value;
        break;

      case "receiverNik":
        currentState.receiverNik = value;
        break;
      case "receiverName":
        currentState.receiverName = value;
        break;
      case "receiverPhone":
        currentState.receiverPhone = value;
        break;
      case "receiverSignature":
        currentState.receiverSignature = value;
        break;
      case "handoverProof":
        currentState.handoverProof = value;
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  beforeUpload = (file: any) => {
    if (!this.state.orderCode) {
      Modal.error({
        title: "Proses Gagal",
        content: "Mohon lengkapi data Order Code",
      });

      this.setState({
        showUploadList: false,
      });
      return false;
    }

    const isImage = file.type.startsWith("image/");
    if (!isImage) {
      Modal.error({
        title: "update Failed",
        content: "mohon upload file dengan tipe image ",
      });
      this.setState({
        showUploadList: false,
      });
    }
    return isImage;
  };

  handleSignatureUpload = (data: any) => {
    if (data?.file?.status === "done") {
      const newImgLocation = data?.file?.response?.data?.url_document;
      const newImgLocationThumb = data?.file?.response?.data?.thumbnail_url;
      this.setState({
        submitting: false,
        receiverSignature: newImgLocation,
        receiverSignatureThumb: newImgLocationThumb,
        showUploadList: true,
      });
    }
    if (data?.file?.status === "uploading") {
      this.setState({
        submitting: true,
      });
    }
    if (data?.file?.status === "removed") {
      this.setState({
        submitting: false,
        receiverSignature: "",
        receiverSignatureThumb: "",
      });
    }
  };

  handleDeliveryProofUpload = (data: any) => {
    if (data?.file?.status === "done") {
      const newImgLocation = data?.file?.response?.data?.url_document;
      const newImgLocationThumb = data?.file?.response?.data?.thumbnail_url;
      this.setState({
        submitting: false,
        handoverProof: newImgLocation,
        handoverProofThumb: newImgLocationThumb,
        showUploadList: true,
      });
    }
    if (data?.file?.status === "uploading") {
      this.setState({
        submitting: true,
      });
    }
    if (data?.file?.status === "removed") {
      this.setState({
        submitting: false,
        handoverProof: "",
        handoverProofThumb: "",
      });
    }
  };

  onReset = async () => {
    await this.promisedSetState({
      ...this.initState,
    });
  };

  fetchOrderData = async () => {
    await this.promisedSetState({
      submitting: true,
    });

    const params = {
      dealerCode: this.state.dealerCode,
      vehicleEngineNumber: this.state.engineNumber,
      statusOrder: "DELIVERED",
      handoverStatus: "BELUM HANDOVER",
    };

    orderService
      .getOrderByStatus(params)
      .then(async (value) => {
        if (Object.keys(value?.data?.data).length > 0) {
          const dataOrder = value?.data?.data[0];
          await this.promisedSetState({
            submitting: false,
            orderCode: dataOrder?.order_code,
            customerName: dataOrder?.customer_name,
            offerCode: dataOrder?.amh_order_number,
            orderStatus: dataOrder?.order_status,
            vehicleVariantName: dataOrder?.vehicle_variant_code + " - " + dataOrder?.vehicle_variant_name,
            marketingName: dataOrder?.marketing_code + " - " + dataOrder?.marketing_name,
            paymentMethod: dataOrder?.order_payment_method,
            receiverNik: dataOrder?.customer_identity_number,
            receiverName: dataOrder?.customer_name,
            receiverPhone: dataOrder?.customer_phone,
          });
        }
      })
      .catch(async (e) => {
        Modal.error({
          title: "Proses Gagal",
          content: "Server Menolak Inputan Anda :" + e.message,
        });
        await this.promisedSetState({
          submitting: false,
        });
      });
  };

  onDeliveryHandover = async () => {
    const currentState: any = { ...this.state };
    if (!currentState.orderCode) {
      Modal.error({ title: "Error", content: "Invalid Order Code" });
      return;
    }
    if (!currentState.handoverDate) {
      Modal.error({ title: "Error", content: "Invalid Tanggal Handover" });
      return;
    }
    if (!currentState.receiverNik) {
      Modal.error({ title: "Error", content: "Invalid NIK Penerima" });
      return;
    }
    if (!currentState.receiverName) {
      Modal.error({ title: "Error", content: "Invalid Nama Penerima" });
      return;
    }
    if (!currentState.receiverPhone) {
      Modal.error({ title: "Error", content: "Invalid Telepon Penerima" });
      return;
    }
    if (!currentState.receiverSignature) {
      Modal.error({ title: "Error", content: "Invalid Tanda Tangan Penerima" });
      return;
    }
    if (!currentState.handoverProof) {
      Modal.error({ title: "Error", content: "Invalid Bukti Serah Terima Kendaraan" });
      return;
    }

    this.setState({ submitting: true });

    const input = {
      dealer_code: currentState.dealerCode,
      order_code: currentState.orderCode,
      handover_date: currentState.handoverDate,
      receiver_nik: currentState.receiverNik,
      receiver_name: currentState.receiverName,
      receiver_phone: currentState.receiverPhone,
      receiver_signature_url: currentState.receiverSignature,
      receiver_signature_thumb_url: currentState.receiverSignatureThumb,
      handover_proof_url: currentState.handoverProof,
      handover_proof_thumb_url: currentState.handoverProofThumb,
      updated_by: this.user,
    };

    try {
      orderService.setToken(this.token);
      await orderService.deliveryHandover(input).then((result) => {
        Modal.success({
          title: "Proses Sukses",
          content: result?.data?.message,
        });

        this.onReset();
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout
          onChangeDealer={this.onDealerChange}
          breadcrumbPath={`Delivery`}
          breadcrumbMenu={`Delivery Handover`}
          defaultSelectedKeys={["m-delivery-handover"]}
          defaultOpenKeys={["sm-delivery"]}
        >
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 18 }} lg={{ span: 18 }} md={{ span: 18 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Mesin <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Space.Compact style={{ width: "100%" }}>
                        <Input type="text" value={this.state.engineNumber} placeholder="Nomor Mesin" onChange={(event) => this.onStringFieldChange("engineNumber", event.target.value)} />
                        <Button type="primary" icon={<SearchOutlined />} onClick={this.fetchOrderData} loading={this.state.submitting} />
                      </Space.Compact>
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tanggal Handover <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <DatePicker
                        value={moment(this.state.handoverDate, "YYYY-MM-DD")}
                        format={"YYYY-MM-DD"}
                        style={{ width: "100%" }}
                        onChange={(date, dateString) => this.onStringFieldChange("handoverDate", dateString)}
                      />
                    </Form.Item>
                  </Col>

                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Kode Order <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.orderCode} placeholder="Kode Order" onChange={(event) => this.onStringFieldChange("orderCode", event.target.value)} disabled />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>Kode Offer</i>
                      <Input type="text" value={this.state.offerCode} placeholder="Kode Offer" disabled />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>Metode Beli</i>
                      <Input type="text" value={this.state.paymentMethod} placeholder="Metode Beli" disabled />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>Order Status</i>
                      <Input type="text" value={this.state.orderStatus} placeholder="Order Status" disabled />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>Variant Kendaraan</i>
                      <Input type="text" value={this.state.vehicleVariantName} placeholder="Variant Kendaraan" disabled />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>Nama Agen</i>
                      <Input type="text" value={this.state.marketingName} placeholder="Nama Agen" disabled />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        NIK Penerima <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.receiverNik} placeholder="NIK Penerima" onChange={(event) => this.onStringFieldChange("receiverNik", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nama Penerima <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.receiverName} placeholder="Nama Penerima" onChange={(event) => this.onStringFieldChange("receiverName", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Telepon Penerima <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="number" value={this.state.receiverPhone} placeholder="Telepon Penerima" onChange={(event) => this.onStringFieldChange("receiverPhone", event.target.value)} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                    <Upload.Dragger
                      name="image"
                      accept="image/*"
                      method="POST"
                      action={baseUrlCdnUpload + "/upload-document/document-data"}
                      listType="picture"
                      maxCount={1}
                      data={{
                        document_name: `signature-${this.state.orderCode.replace(/#/g, "-")}`,
                        document_type: "signature",
                        source: "app.otodis.com",
                      }}
                      onChange={this.handleSignatureUpload}
                      beforeUpload={this.beforeUpload}
                      style={{ width: "100%", height: 200 }}
                      showUploadList={false}
                    >
                      {this.state.receiverSignature ? (
                        <img src={this.state.receiverSignature} alt="Tanda Tangan" style={{ height: 200 }} />
                      ) : (
                        <div>
                          <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">Klik atau Drag untuk mengupload File</p>
                          <p className="ant-upload-hint">Upload tanda tangan penerima</p>
                        </div>
                      )}
                    </Upload.Dragger>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                    <Upload.Dragger
                      name="image"
                      accept="image/*"
                      method="POST"
                      action={baseUrlCdnUpload + "/upload-document/document-data"}
                      listType="picture"
                      maxCount={1}
                      data={{
                        document_name: `receipt_of_goods-${this.state.orderCode.replace(/#/g, "-")}`,
                        document_type: "receipt_of_goods",
                        source: "app.otodis.com",
                      }}
                      onChange={this.handleDeliveryProofUpload}
                      beforeUpload={this.beforeUpload}
                      style={{ width: "100%", height: 200 }}
                      showUploadList={false}
                    >
                      {this.state.handoverProof ? (
                        <img src={this.state.handoverProof} alt="Bukti Serah Terima" style={{ height: 200 }} />
                      ) : (
                        <div>
                          <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                          </p>
                          <p className="ant-upload-text">Klik atau Drag untuk mengupload File</p>
                          <p className="ant-upload-hint">Upload bukti serah terima kendaraan</p>
                        </div>
                      )}
                    </Upload.Dragger>
                  </Col>
                </Row>
                <br />{" "}
              </Col>
            </Row>

            <Row style={{ marginTop: 20 }}>
              <Col xl={{ span: 6 }} lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onDeliveryHandover} style={{ width: "100%" }}>
                      Simpan Data
                    </Button>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} danger icon={<UndoOutlined />} onClick={this.onReset} loading={this.state.submitting} style={{ width: "100%" }}>
                      Reset Form
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(DeliveryHandover), 53);
